<div class="dsp-login-container">
  <dsp-qa-banner></dsp-qa-banner>
  <dsp-header></dsp-header>
  <div class="dsp-login-content">
    <ng-container *ngIf="loading$ | async">
      <div class="dsp-loader"></div>
    </ng-container>
    <ng-container *ngIf="!(loading$ | async)">
      <router-outlet></router-outlet>
    </ng-container>
  </div>
  <dsp-footer></dsp-footer>
</div>
